import ImageCarousel from '../../components/imageCarousel';
import Room from '../../interfaces/room';

type RoomDetailsProps = {
  room: Room;
};

const RoomDetails = ({ room }: RoomDetailsProps) => {
  return (
    <article className="facility-card">
      <ImageCarousel images={room.images} alt={room.name} />
      <div className="facility-body">
        <h3>{room.name}</h3>
        <p>{room.description}</p>
      </div>
    </article>
  );
};

export default RoomDetails;
